// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-password-container {
  max-width: 500px; 
  margin: 0px auto;
  padding: 15px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}
 
.change-password-container .title {
  color: #014d4e; /* text color changed*/
  font-size: 22px;
  font-weight: bold;
}
 
.change-password-container .subtitle {
  color: #555;
  margin-bottom: 20px;
}
 
/* ✅ Added spacing for messages */
.change-password-container .message-container {
  margin-bottom: 15px; /* ✅ Adds space between messages & Current Password field */
}
 
.change-password-container .password-input {
  width: 100%;
  margin-bottom: 15px;
}
 
/* ✅ Password Criteria Styling */
.change-password-container .password-criteria {
  text-align: left;
  font-size: 14px;
  margin-bottom: 15px;
}
 
.change-password-container .password-criteria p {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 4px 0;
}
 
.change-password-container .check-icon {
  color: #bbb; /* ⚪ Light gray by default */
  font-size: 16px;
  transition: color 0.3s ease-in-out;
}
 
.change-password-container .checked {
  color: #34a853 !important; /* ✅ Turns green when condition is met */
}
 
.change-password-container .valid {
  color: #34a853; /* ✅ Soft green text for valid conditions */
}
 
.change-password-container .pending {
  color: #888; /* ⚪ Soft gray for unmet conditions */
}
 
.change-password-container .submit-button {
  width: 100%;
  background-color: #1f415b; /*button color changed*/
  border: none;
}
 
.change-password-container .submit-button:hover {
  background-color: #1677ff; /* button hover color changed*/
}
 
.change-password-container .ant-alert-error {
  background: #fff2f0;
  border: 1px solid #ffccc7;
  margin-bottom: 15px; /* added spacing for alert */
}
 `, "",{"version":3,"sources":["webpack://./src/gitsubmodules/onboarding/src/components/ChangePassword/ChangePassword.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,sBAAsB;EACtC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB,EAAE,2DAA2D;AAClF;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,WAAW,EAAE,4BAA4B;EACzC,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,yBAAyB,EAAE,wCAAwC;AACrE;;AAEA;EACE,cAAc,EAAE,2CAA2C;AAC7D;;AAEA;EACE,WAAW,EAAE,qCAAqC;AACpD;;AAEA;EACE,WAAW;EACX,yBAAyB,EAAE,uBAAuB;EAClD,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB,EAAE,4BAA4B;AACnD","sourcesContent":[".change-password-container {\n  max-width: 500px; \n  margin: 0px auto;\n  padding: 15px;\n  border-radius: 8px;\n  background-color: white;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n \n.change-password-container .title {\n  color: #014d4e; /* text color changed*/\n  font-size: 22px;\n  font-weight: bold;\n}\n \n.change-password-container .subtitle {\n  color: #555;\n  margin-bottom: 20px;\n}\n \n/* ✅ Added spacing for messages */\n.change-password-container .message-container {\n  margin-bottom: 15px; /* ✅ Adds space between messages & Current Password field */\n}\n \n.change-password-container .password-input {\n  width: 100%;\n  margin-bottom: 15px;\n}\n \n/* ✅ Password Criteria Styling */\n.change-password-container .password-criteria {\n  text-align: left;\n  font-size: 14px;\n  margin-bottom: 15px;\n}\n \n.change-password-container .password-criteria p {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 4px 0;\n}\n \n.change-password-container .check-icon {\n  color: #bbb; /* ⚪ Light gray by default */\n  font-size: 16px;\n  transition: color 0.3s ease-in-out;\n}\n \n.change-password-container .checked {\n  color: #34a853 !important; /* ✅ Turns green when condition is met */\n}\n \n.change-password-container .valid {\n  color: #34a853; /* ✅ Soft green text for valid conditions */\n}\n \n.change-password-container .pending {\n  color: #888; /* ⚪ Soft gray for unmet conditions */\n}\n \n.change-password-container .submit-button {\n  width: 100%;\n  background-color: #1f415b; /*button color changed*/\n  border: none;\n}\n \n.change-password-container .submit-button:hover {\n  background-color: #1677ff; /* button hover color changed*/\n}\n \n.change-password-container .ant-alert-error {\n  background: #fff2f0;\n  border: 1px solid #ffccc7;\n  margin-bottom: 15px; /* added spacing for alert */\n}\n "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
